import { Button, IconButton, Popover, useTheme } from '@mui/material';
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { ProjectDTO, ProjectType } from '../Api/ApiServer';
import { EditRoadOutlined, MoreVert, NavigateNext } from '@mui/icons-material';
import { useValidatorStore } from '../CurveSolver/Stores/ValidatorStore';
import { ValidatorsEnum } from '../CurveSolver/Enums/ValidatorsEnum';

interface ProjectItemSceneProps {
    project: ProjectDTO;
    onDeleteProject(projectId: number): void;
    onUpdateProject(projectId: number): void;
    onlySlope?: boolean;
    onlyCurve?: boolean;
}

export default function ProjectItemScene(props: ProjectItemSceneProps) {
    const { project, onDeleteProject, onUpdateProject } = props;
    const theme = useTheme();
    // console.log(theme);
    const [name, setName] = React.useState("");

    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const openUserMenu = Boolean(anchorEl);
    const [open, setOpen] = React.useState(false);
    const id = open ? 'simple-popover' : undefined;

    const { validator } = useValidatorStore();

    const handleUserMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);

    };

    const getProjectImage = () => {
        if (project.type === ProjectType.Road) return process.env.PUBLIC_URL + "/road.png";
        if (project.type === ProjectType.Railway) return process.env.PUBLIC_URL + "/rail.png";
        if (project.type === ProjectType.RoadBridge) return process.env.PUBLIC_URL + "/roadBridge.png";
        if (project.type === ProjectType.RailwayBridge) return process.env.PUBLIC_URL + "/railBridge.png";
        return process.env.PUBLIC_URL + "/noProjectPicture.png";
    };

    const getToolInfo = () => {
        if (props.onlySlope) return { icon: <EditRoadOutlined style={{ height: '20px', width: '20px', color: theme.palette.primary.main }} />, label: 'SlopeGuard' };
        if (props.onlyCurve) return { icon: <img style={{ height: '20px', width: '20px' }} src={process.env.PUBLIC_URL + "/gpk_icon.png"} alt="GPK" />, label: 'GPK Validátor' };
        if (validator === ValidatorsEnum.SlopeGuard) return { icon: <EditRoadOutlined style={{ height: '20px', width: '20px', color: theme.palette.primary.main }} />, label: 'SlopeGuard' };
        return { icon: <img style={{ height: '20px', width: '20px' }} src={process.env.PUBLIC_URL + "/gpk_icon.png"} alt="GPK" />, label: 'GPK Validátor' };
    };

    const toolInfo = getToolInfo();

    return (
        <div
            style={{
                background: 'white',
                borderRadius: '12px',
                boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'box-shadow 0.25s ease, transform 0.25s ease',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 1px 6px rgba(0,0,0,0.08)';
                e.currentTarget.style.transform = 'translateY(0)';
            }}
            onClick={() => navigate('/routes/' + project.id)}
        >
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 6px 10px 16px' }}>
                <div style={{ color: theme.palette.primary.main, fontWeight: 700, fontSize: '15px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                    {project.name}
                </div>
                <IconButton size="small" onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleUserMenuClick(e); }}>
                    <MoreVert fontSize="small" />
                </IconButton>
                <Popover
                    id={id}
                    sx={{ zIndex: 50002 }}
                    open={openUserMenu}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                    <div style={{ padding: '4px 0' }}>
                        <div>
                            <Button color="secondary" sx={{ width: "170px", justifyContent: "flex-start", fontSize: '12px', padding: '8px 16px' }}
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (project && project.id) { onUpdateProject(project.id!); handleClose(); } }}>
                                Upravit projekt
                            </Button>
                        </div>
                        <div>
                            <Button color="secondary" sx={{ width: "170px", justifyContent: "flex-start", fontSize: '12px', padding: '8px 16px' }}
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (project && project.id) { onDeleteProject(project.id!); handleClose(); } }}>
                                Smazat projekt
                            </Button>
                        </div>
                    </div>
                </Popover>
            </div>

            {/* Project image */}
            <div style={{ height: '170px', overflow: 'hidden', borderTop: '1px solid #f0f0f0' }}>
                <img style={{ height: '100%', width: '100%', objectFit: 'cover' }} src={getProjectImage()} alt={project.name || ''} />
            </div>

            {/* Footer with tool indicator */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px', borderTop: '1px solid #f0f0f0' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {toolInfo.icon}
                    <span style={{ fontSize: '13px', color: '#666', fontWeight: 600 }}>{toolInfo.label}</span>
                </div>
                <NavigateNext style={{ color: '#bbb', fontSize: '20px' }} />
            </div>
        </div>
    );
}
